import QuestionPage from '@app-studio-web/ui/pages/QuestionPage'
import { useTranslation } from 'react-i18next'
import { useSubmit } from 'react-router-dom'

export default function GenderPage() {
  const submit = useSubmit()
  const { t } = useTranslation()

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    submit(event.currentTarget)
  }

  return (
    <QuestionPage
      heading={t('pages.onboarding.gender.heading')}
      buttons={[
        { text: t('pages.onboarding.gender.options.female'), value: 'female' },
        { text: t('pages.onboarding.gender.options.male'), value: 'male' },
      ]}
      onSubmit={handleSubmit}
    />
  )
}
